module.exports = {
  betaBanner: true,
};
